// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"40":"5cbc25c6","49":"2fcc6b13","93":"20a03a74","205":"7d10a241","654":"05595eab","772":"1d4a1966","881":"9f6821b2","893":"2bd19aad","949":"65cea462","978":"fee540d5"}[chunkId] + ".js";
};